import React, { useMemo } from 'react';
import { ClapperboardIcon } from 'lucide-react';
import type { Widget } from '@airhead-games/shared/content';
import { getClipsByGame } from '@airhead-games/shared/utilities';
import {
  DEFAULT_CLIP_BATCH_SIZE,
  planClipOrder,
  Rail,
} from '@/components/clips';
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

interface WidgetClipRailProps {
  widget: Extract<Widget, { type: 'clipScroller' }>;
}

const WidgetClipRail: React.FC<WidgetClipRailProps> = ({ widget }) => {
  const clips = useMemo(
    () =>
      planClipOrder(getClipsByGame(widget.gameId), {
        gameIds: [widget.gameId],
        batchSize: DEFAULT_CLIP_BATCH_SIZE,
      }),
    [widget.gameId]
  );

  if (clips.length === 0) {
    return (
      <Empty className="min-h-[332px] border">
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <ClapperboardIcon aria-hidden="true" />
          </EmptyMedia>
          <EmptyTitle>No clips yet</EmptyTitle>
          <EmptyDescription>
            Gameplay clips will appear here once they are available.
          </EmptyDescription>
        </EmptyHeader>
      </Empty>
    );
  }

  return (
    <Rail
      clips={clips}
      showGameChip={false}
      initialEagerCount={DEFAULT_CLIP_BATCH_SIZE}
      batchSize={DEFAULT_CLIP_BATCH_SIZE}
    />
  );
};

export default WidgetClipRail;
